export default __webpack_public_path__ + "images/P6.cb98e76.png";